import React, { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import DefaultRedirect from '../components/DefaultRedirect/DefaultRedirect';
import PageLoader from '../components/PageLoader/PageLoader';
import { isAppShell } from './utils/isInstalledApp';

const MarketingHome = lazy(() => import('./MarketingHome'));

const RootGate: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <PageLoader />;
  }

  if (isAppShell()) {
    if (isAuthenticated) {
      return <DefaultRedirect />;
    }
    return <Navigate to="/login" replace />;
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <MarketingHome />
    </Suspense>
  );
};

export default RootGate;
